const rankingItems = [
  { rank: 1, title: '七月探花大神精选合集 · 夏日限定', views: '12.8k', tag: '探花精选', trend: 'up', hot: true },
  { rank: 2, title: '探花一区「新人大赏」高分作品盘点', views: '10.5k', tag: '探花一区', trend: 'up', hot: true },
  { rank: 3, title: '探花91社区本周热门内容TOP10', views: '9.2k', tag: '探花91', trend: 'stable', hot: true },
  { rank: 4, title: '九一探花经典系列完整合集整理', views: '8.1k', tag: '九一探花', trend: 'up', hot: false },
  { rank: 5, title: '极品探花月度高分推荐榜单', views: '7.3k', tag: '极品探花', trend: 'stable', hot: false },
  { rank: 6, title: '探花探花社区口碑佳作精选集', views: '6.6k', tag: '探花探花', trend: 'up', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-trophy-line"></i>
              热门榜单
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              排行榜
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-medium text-accent-700 bg-accent-100/80 px-3 py-1 rounded-full">本周热门</span>
            <span className="text-xs font-medium text-foreground-500 bg-background-200 px-3 py-1 rounded-full cursor-pointer hover:bg-background-300 transition-colors">本月精选</span>
            <span className="text-xs font-medium text-foreground-500 bg-background-200 px-3 py-1 rounded-full cursor-pointer hover:bg-background-300 transition-colors">历史经典</span>
          </div>
        </div>

        <div className="space-y-2">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="text-[10px] font-medium text-primary-600 bg-primary-100/80 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="text-[10px] font-medium text-accent-600 bg-accent-100/80 px-1.5 py-0.5 rounded whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
                <i className={`text-sm ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-green-500' : 'ri-subtract-line text-foreground-400'
                }`}></i>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}